import BasicConfirmModal from './basic_confirm_modal';
import * as constants from './constants';

export default BasicConfirmModal;
export { constants };
